import { useState } from 'react';
import axios from 'axios';
import UserForm from '../components/User/UserForm';
import FormSuccess from '../components/FormSuccess/FormSuccess';

const Home = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleFormSubmit = async (formData) => {
    try {
      await axios.post('http://localhost:5000/api/forms/submit', formData);
      setFormSubmitted(true);
    } catch (error) {
      alert('Error submitting form. Please try again.');
      console.error('Form submission error:', error);
    }
  };

  if (formSubmitted) {
    return <FormSuccess onReset={() => setFormSubmitted(false)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      {/* Form Section */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Get Your  Quote
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
              Complete the form below and take the first step toward your project transformation
            </p>
          </div>
          
          <div className="max-w-6xl mx-auto">
            <UserForm onSubmit={handleFormSubmit} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;